<script>
	import Router from './routes/_router.svelte'
	import { onMount } from 'svelte'
	import { CheckWidth, Initialsetting, CheckLimitDate } from './script/_handle'

	let innerWidth = 0
	
	onMount(async () => {	
		/*let checkDate = CheckLimitDate()
		if(checkDate) {
			alert('이사로 인해 서버 이용이 불가하여 25.04.02부터 사용이 불가합니다.(오픈 시기 미정)')
		}
		else {*/
			CheckWidth(innerWidth)
			
			// 페이지 초기 세팅
			await Initialsetting()
		//}
    })
</script>

<svelte:window
	bind:innerWidth
	on:resize={() => CheckWidth(innerWidth)}
/>

<svelte:head>
	<script
		async
		src="https://www.googletagmanager.com/gtag/js?id=G-PW06X334C1">
	</script>
	<script>
		window.dataLayer = window.dataLayer || [];

		function gtag(){
			dataLayer.push(arguments);
		}

		gtag('js', new Date());
		gtag('config', 'G-PW06X334C1');
	</script>
</svelte:head>

<main>
	<Router />
</main>

<style lang='scss'>
	
</style>